import { Component, OnInit, inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { catchError } from "rxjs/operators";

import { empty } from "../../../../functions";
import { AlertService } from "../../../../shared/services/alert.service";
import { AdminService } from "../../../../shared/services/admin.service";
import { SchoolService } from "../../../../api/services/school.service";
import { FilterOptionsService } from "../../../../shared/services/filter-options.service";
import { EducationLevel } from "../../../../api/models/education-level";
import { SchoolClass } from "../../../../api/models/school-class";

@Component({
  selector: "app-modal-admin-school-class",
  templateUrl: "./modal-admin-school-class.component.html",
  standalone: false,
})
export class ModalAdminSchoolClassComponent implements OnInit {
  readonly activeModal = inject(NgbActiveModal);
  private readonly alertService = inject(AlertService);
  private readonly adminService = inject(AdminService);
  private readonly schoolService = inject(SchoolService);
  private readonly filterOptionsService = inject(FilterOptionsService);

  public data: any;

  schoolId = "";

  entity: SchoolClass = {};

  educationLevels: EducationLevel[] = [];

  ngOnInit(): void {
    this.schoolId = this.data.schoolId;

    if (this.data.entity) {
      this.entity = { ...this.data.entity };
      if (this.entity.educationLevel) {
        this.entity.educationLevelId = this.entity.educationLevel.id;
      }
    }

    this.educationLevels = this.filterOptionsService.educationLevelsRaw();
  }

  Save() {
    if (!this.entity.name) {
      this.alertService.error("Please fill in the class name");
      return;
    }

    const body: SchoolClass = {
      name: this.entity.name,
      grade: this.entity.grade,
      educationLevelId: this.entity.educationLevelId || null,
      internshipsAllowed: this.entity.internshipsAllowed || false,
    };

    if (!empty(this.entity.id)) {
      // Update
      this.schoolService
        .updateSchoolClass({
          schoolId: this.schoolId,
          id: this.entity.id!,
          body,
        })
        .pipe(
          catchError(this.adminService.handleError("updateSchoolClass", false))
        )
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    } else {
      // Create
      this.schoolService
        .createSchoolClass({
          schoolId: this.schoolId,
          body,
        })
        .pipe(
          catchError(this.adminService.handleError("createSchoolClass", false))
        )
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    }
  }
}
